import * as React from 'react';
import {FC} from 'react';
import {Create, CreateProps, SimpleForm, TextInput, SelectInput} from 'react-admin';

import {filterProps} from "../../../functions/common";
import Title from "../../../components/list/Title";
import frameMaterialOptions from "./frameMaterialOptions";

const FrameCreate: FC<CreateProps> = props => {
    const newProps = filterProps(props);

    return (
        <Create {...newProps}>
            <SimpleForm>
                <Title label="resources.admin/kdh-frames.titles.create"/>
                <TextInput autoFocus source="matnr" fullWidth={true}/>
                <SelectInput source="material" choices={frameMaterialOptions.map(el => ({id: el, name: el}))}/>
                <TextInput source="cut_out_size"/>
            </SimpleForm>
        </Create>
    );
};

export default FrameCreate;
